<template>
  <div
    v-if="number > 0"
    v-text="showNum"
    :class="(number >= 10 || needAddSymbol) ? 'normal' : 'round'"
    class="SouhuoH5Sohobadge"
  ></div>
</template>

<script>
export default {
  name: "SouhuoH5Sohobadge",

  props: {
    number: {
      type: Number || String,
      default: () => {
        return "0";
      },
    },
    needAddSymbol: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  
  computed: {
    showNum () {
        if (this.number > 99) {
            return `99+`
        }
        if (this.needAddSymbol) {
            return `+${this.number}`
        } else {
            return `${this.number}`
        }
    }
  },

  data() {
    return {
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.SouhuoH5Sohobadge {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 18px;
  background-color: red;
  color: #fff;
  font-size: 14px;
  &.round {
    width: 18px;
    border-radius: 50%;
  }
  &.normal {
    padding: 0 4px;
    border-radius: 9px;
  }
}
</style>